import { Hr_Race } from "@/graphql/gql/graphql";
import RaceInfo from "../raceInfo";
import styles from "./trackRaces.module.scss";

const TrackRaces = ({ races }: { races: Hr_Race[] }) => (
  <div className={styles.container}>
    {races.map((race) => (
      <RaceInfo key={`${race.number} + ${race.track?.code}`} race={race} />
    ))}
  </div>
);

export default TrackRaces;
